<template>

  <div>
    <v-row class="justify-center">
      <v-col lg="12" class="display-3 pb-0 pt-0">
        <h1 class="font-weight-bold text-center mb-0 tw-leading-10">Open Batch Information
        </h1>
      </v-col>
      </v-row>
      <v-row class="mb-1 justify-center">
        <v-col lg="3" class="display-3 ml-2 pb-0">
          <v-card class="mx-auto rounded-lg" elevation="12">
            <v-list-item>
              <v-list-item-avatar tile size="30">
                <Icon icon="wallet" color="#3a00ff" />
              </v-list-item-avatar>
              <v-list-item-content class="py-2">
                <v-list-item-title class="headline mb-1">
                  {{ data.transactionsToday | simpleNumber }}
                </v-list-item-title>
                <v-list-item-subtitle class="black--text font-weight-bold">
                  Transactions
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col lg="3" class="display-3 ml-2 pb-0">
          <v-card class="mx-auto rounded-lg" elevation="12">
            <v-list-item>
              <v-list-item-avatar tile size="30">
                <Icon icon="money-bill-alt" color="#00ff00" />
              </v-list-item-avatar>
              <v-list-item-content class="py-2">
                <v-list-item-title class="headline mb-1">
                  {{ dollarFormattedValueOrZero(data.today.authorized) }}
                </v-list-item-title>
                <v-list-item-subtitle class="black--text font-weight-bold">
                  Authorized
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col lg="3" class="display-3 ml-2 pb-0">
          <v-card class="mx-auto rounded-lg" elevation="12">
            <v-list-item>
              <v-list-item-avatar tile size="30">
                <Icon icon="money-bill-alt" color="#00ff00" />
              </v-list-item-avatar>
              <v-list-item-content class="py-2">
                <v-list-item-title class="headline mb-1">
                  {{ dollarFormattedValueOrZero(data.today.captured) }}
                </v-list-item-title>
                <v-list-item-subtitle class="black--text font-weight-bold">
                  Captured
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
  </div>

</template>

<script>
import Icon from '@/common/icon';
import '../../../assets/css/isodashboardtop.css';

export default {
  props: {
    data: {
      required: true,
    },
  },
  methods: {
    dollarFormattedValueOrZero(value) {
      return this.dollarFormattedValue(value) || '$0.00';
    },
    dollarFormattedValue(value) {
      const format = this.$options.filters.dollarsAndCents;
      return value ? `$${format(value)}` : null;
    },
  },
  components: {
    Icon,
  },
};
</script>
